<template>
  <div>
    <v-container fluid v-if="!window" class="h-full">
      <h2 class="titleComponentBody">Hola {{ userSession.name }} !</h2>
      <v-divider class="mb-5"></v-divider>
      <div class="content d-flex flex-column flex-md-row flex-wrap h-full">
        <v-card
          class="listado d-flex flex-column justify-center align-center elevation-5"
        >
          <h2>LISTADO DE TASACIONES</h2>
          <v-btn
            depressed
            color="primary"
            @click="
              window = true;
              titleWindow = 'Listado de tasaciones';
              appraisalList = true;
            "
          >
            ENTRAR
          </v-btn>
        </v-card>
        <v-card
          class="tasar d-flex flex-column justify-center align-center elevation-5"
        >
          <h2>TASAR VEHÍCULO</h2>
          <v-btn
            depressed
            color="primary"
            @click="
              window = true;
              titleWindow = 'Tasar vehículo';
              newAppraisal = true;
            "
          >
            ENTRAR
          </v-btn>
        </v-card>
        <v-divider class="mt-5"></v-divider>
        <!-- <v-card
          class="perfil d-flex flex-column justify-center align-center elevation-5"
        >
          <h2>MI PERFIL</h2>
          <v-btn
            depressed
            color="primary"
            @click="
              window = true;
              titleWindow = 'Mi perfil';
              profile = true;
            "
          >
            ENTRAR
          </v-btn>
        </v-card> -->
      </div>
    </v-container>
    <v-container fluid v-else>
      <h2 class="titleComponentBody">
        <v-btn
          icon
          @click="
            window = false;
            titleWindow = '';
            appraisalList = false;
            newAppraisal = false;
            profile = false;
          "
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        {{ titleWindow }}
      </h2>
      <v-divider class="mb-5"></v-divider>
      <AppraisalsList v-if="appraisalList" />
      <NewAppraisal v-if="newAppraisal" />
      <Profile v-if="profile" />
    </v-container>
  </div>
</template>

<script>
import AppraisalsList from "../ContentHome/Sections/Appraisals-list.vue";
import NewAppraisal from "../ContentHome/Sections/New-appraisal.vue";
import Profile from "../ContentHome/Sections/Profile.vue";
export default {
  components: {
    AppraisalsList,
    NewAppraisal,
    Profile
  },

  created() {
    this.userSession = JSON.parse(sessionStorage.vuex).userLogged;
  },

  data: () => ({
    userSession: null,
    appraisalList: false,
    newAppraisal: false,
    profile: false,
    window: false,
    titleWindow: "",
    e1: 1,
    reveal: false,
    data: {
      tasaciones: "",
      perfil: ""
    },
    formData: {
      idAppraisal: "",
      group1: {
        empresa: "",
        dni: "",
        direccion: "",
        localidad: "",
        provincia: "",
        cp: "",
        pais: ""
      }
    }
  })
};
</script>

<style scoped>
.h-full {
  height: 100vh;
}
.titleComponentBody {
  margin: 30px 10px;
}
.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}
.content > * {
  flex: 1;
  height: 600px;
  margin: 0 5px;
}

.content h2 {
  color: white;
}
.content .listado {
  background-color: #b5b3b3;
  margin-bottom: 10px;
  /* background: url("https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/681px-Placeholder_view_vector.svg.png")
    no-repeat;
  background-size: cover;
  background-position: center; */
}
.listado h2 {
  margin-bottom: 20px;
}
.content .tasar {
  background-color: #b5b3b3;
  /* background: url("https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/681px-Placeholder_view_vector.svg.png")
    no-repeat;
  background-size: cover;
  background-position: center; */
}
.tasar h2 {
  margin-bottom: 20px;
}
.content .perfil {
  background-color: #7f7e7e;
  /* background: url("https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/681px-Placeholder_view_vector.svg.png")
    no-repeat;
  background-size: cover;
  background-position: center; */
}
.perfil h2 {
  margin-bottom: 20px;
}
</style>
